import { SideSheetContentCol, Button, ButtonAppearance, Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const SideSheetContentLeftColStyled = styled(SideSheetContentCol)`
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);
  flex-basis: 30%;
  z-index: 1;
`;

interface SideSheetContentRightColStyledProps {
  disabled: boolean;
}

export const SideSheetContentRightColStyled = styled(SideSheetContentCol)`
  flex-basis: 70%;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
  `}
  ${(props: SideSheetContentRightColStyledProps) =>
    props.disabled
      ? css`
          pointer-events: none;
          opacity: 0.5;
        `
      : css`
          opacity: 1;
        `}
`;

export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const EllipseStyled = styled(Box).attrs({ mx: { sm: '400' }, alignSelf: { sm: 'center' } })`
  ${({ theme }) => css`
    width: ${theme.spacings[100]};
    height: ${theme.spacings[100]};
    background-color: ${theme.colors.grey[700]};
  `}
`;

export const AddCaddyContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
  py: { sm: '400' },
  px: { sm: '450' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `};
`;
